import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import { Box } from '@origin-digital/layout';
import { mapColorLabelToHex } from '@origin-digital/helper';
import { ClearIcon } from '@origin-digital/icon';
import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import * as PropTypes from 'prop-types';
import { tint, transparentize } from 'polished';
import { AlertBox, AlertBoxTypes, getAlertColorLabel } from '../AlertBox';
import { IconButton } from '../IconButton';
import { BREAK_POINTS, ZIndexes } from '../../consts';

var mediaQueryForBreakpoint = function mediaQueryForBreakpoint(breakpoint, fixedTopPosition) {
  if (fixedTopPosition) {
    return css(["@media (max-width:", "){", ";}"], breakpoint, "top:".concat(fixedTopPosition));
  }

  return null;
};

function getAlertCloseColorLabel(type) {
  return type === 'info' ? 'grey' : type === 'success' ? 'green' : 'redPink';
}

var slideDown = keyframes(["0%{transform:translateY(-100%);opacity:0;}to{transform:translateY(0);opacity:1;}"]);
var Sticky = styled.div.withConfig({
  displayName: "AlertBanner__Sticky",
  componentId: "x63kbi-0"
})(["position:relative;position:sticky;top:0;width:100%;height:0;z-index:", ";", ";", ";", ";", ";"], ZIndexes.STICKY_HEADER, function (props) {
  return mediaQueryForBreakpoint(BREAK_POINTS.Max.XL, props.fixedPositions.XL);
}, function (props) {
  return mediaQueryForBreakpoint(BREAK_POINTS.Max.LG, props.fixedPositions.LG);
}, function (props) {
  return mediaQueryForBreakpoint(BREAK_POINTS.Max.MD, props.fixedPositions.MD);
}, function (props) {
  return mediaQueryForBreakpoint(BREAK_POINTS.Max.SM, props.fixedPositions.SM);
});
var AlertBoxContainer = styled.div.withConfig({
  displayName: "AlertBanner__AlertBoxContainer",
  componentId: "x63kbi-1"
})(["width:100%;margin:auto;@media (min-width:", "){max-width:540px;}@media (min-width:", "){max-width:720px;}@media (min-width:", "){max-width:960px;}@media (min-width:", "){max-width:1140px;}"], BREAK_POINTS.Min.SM, BREAK_POINTS.Min.MD, BREAK_POINTS.Min.LG, BREAK_POINTS.Min.XL);
var AlertBannerBackground = styled.div.withConfig({
  displayName: "AlertBanner__AlertBannerBackground",
  componentId: "x63kbi-2"
})(["background-color:", ";border-bottom:1px solid ", ";animation:", " ease-out 0.22s forwards;"], function (_ref) {
  var color = _ref.color;
  return transparentize(0.04, tint(0.08, color));
}, function (_ref2) {
  var color = _ref2.color;
  return transparentize(0.04, tint(0.16, color));
}, slideDown);

var AlertBanner = function AlertBanner(_ref3) {
  var children = _ref3.children,
      message = _ref3.message,
      heading = _ref3.heading,
      _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? AlertBoxTypes.ERROR : _ref3$type,
      _ref3$fixedPositions = _ref3.fixedPositions,
      fixedPositions = _ref3$fixedPositions === void 0 ? {} : _ref3$fixedPositions,
      onClose = _ref3.onClose,
      _ref3$dataId = _ref3['data-id'],
      dataId = _ref3$dataId === void 0 ? 'alertBanner' : _ref3$dataId,
      trackingDisabled = _ref3.trackingDisabled;
  var colorLabel = getAlertColorLabel(type);
  var colorHex = mapColorLabelToHex(colorLabel);
  var colorClose = getAlertCloseColorLabel(type);
  return React.createElement(Sticky, {
    fixedPositions: fixedPositions
  }, React.createElement(AlertBannerBackground, {
    color: colorHex
  }, React.createElement(AlertBoxContainer, null, React.createElement(Box, {
    display: "flex",
    alignItems: "flex-start",
    direction: "row"
  }, React.createElement(Box, {
    flex: "grow"
  }, React.createElement(AlertBox, {
    message: children ? undefined : message,
    heading: heading,
    type: type,
    markdown: true,
    _transparent: true
  }, children)), React.createElement(Box, {
    paddingY: 1
  }, React.createElement(IconButton, {
    icon: ClearIcon,
    color: colorClose,
    onClick: onClose,
    label: heading,
    accessibilityLabel: "close",
    componentType: "AlertBanner",
    "data-id": dataId,
    postClickState: "closed",
    trackingDisabled: trackingDisabled
  }))))));
};

AlertBanner.propTypes = _Object$assign({}, AlertBox.propTypes, {
  fixedPositions: PropTypes.shape({
    SM: PropTypes.string,
    MD: PropTypes.string,
    LG: PropTypes.string,
    XL: PropTypes.string
  }),
  onClose: PropTypes.func
});
export { AlertBanner };